import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import reactChildrenLike from 'utils/react/childrenLike.util';

import CN from './DropdownFoldout.module.scss';

const Header = ({ children }) => <>{children}</>;
const Body = ({ children }) => <>{children}</>;
const Footer = ({ children }) => <>{children}</>;

const DropdownFoldout = ({ tag, children, variant, position, width, onClickOutside, refFromProps }) => {
  const { isDarkMode } = useTheme();
  const ref = useRef(null);

  useClickAway(refFromProps ?? ref, () => {
    if (onClickOutside) {
      onClickOutside();
    }
  });

  const headChildren = reactChildrenLike(Header, children);
  const bodyChildren = reactChildrenLike(Body, children);
  const footChildren = reactChildrenLike(Footer, children);

  const t = fromAnyToTrimmed(tag);

  return (
    <div
      ref={ref}
      data-bem="DropdownFoldout__content"
      data-tag={t}
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
        [CN[`${variant}Variant`]]: variant,
        [CN[`${position}Position`]]: position, // above or below button
        [CN[`${width}Width`]]: width, // By default, it's fixed, but it can also be full width, and we need to declare it
      })}
    >
      <div data-bem="DropdownFoldout__header" data-tag={t} className={CN.header}>
        {headChildren}
      </div>

      <div data-bem="DropdownFoldout__body" data-tag={t} className={CN.body}>
        {bodyChildren}
      </div>
      <div data-bem="DropdownFoldout__footer" data-tag={t} className={CN.footer}>
        <div className={CN.buttonContainer}>{footChildren}</div>
      </div>
    </div>
  );
};

DropdownFoldout.Header = Header;
DropdownFoldout.Body = Body;
DropdownFoldout.Footer = Footer;

export default DropdownFoldout;
